'use strict';
module Patersons {

    export interface MarketHeatmapScope extends ng.IScope {
        events: Patersons.MarketHeatmapCtrl;
    }

    export class MarketHeatmapCtrl extends AnalysisBaseCtrl {
        scope: Patersons.MarketHeatmapScope;
        analysisService: Patersons.AnalysisService;
        morningStarService: Patersons.MorningStarService;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService', 'analysisService', 'morningStarService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService, analysisService, morningStarService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.rootScope = $rootScope;
            this.analysisService = analysisService;
            this.morningStarService = morningStarService;
            this.load();

        }
        transformWatchlistToMorningStarWatchlist(watchlists: Watchlist[]){
            // due to a request to only show stock tickers that are not of type Fund (holdingtypeId = 2),
            // we need to query the M* API to determine if a particular ticker is infact a fund or not
            // and use that information to show/hide the tickers from the heatmap component.
            return new Promise(resolveAll => {
                var mWatchlists = []
                Promise.all(watchlists.map((watchlist) => {
                    return new Promise(resolveEach => {
                        let mWatchlist = {
                            name: watchlist.name,
                            data: [],
                            id: "m" + watchlist.id
                        }
                        Promise.all(watchlist.watchlistItems.map((ticker) => {
                            return new Promise(resolveTicker => {
                                this.morningStarService.getMorningStarDataForSecurityId(ticker).then((res) => {
                                    if(res){
                                        let holdingTypeId = res.holdingTypeId;
                                        if(holdingTypeId != 2){
                                            mWatchlist.data.push({ticker: ticker})
                                        }
                                    }
                                    resolveTicker()
                                })
                            })
                        })).then(() => {
                            mWatchlists.push(mWatchlist)
                            resolveEach();
                        })
                    })
                })).then(() => {
                    resolveAll(mWatchlists)
                })
            })

            // This is kept incase we dont need to check each ticker
            // return watchlists.map(function (watchlist) {
            //     return {
            //         name: watchlist.name,
            //         data: watchlist.watchlistItems.map(function (isin) {
            //             return {
            //                 ticker: isin
            //             }
            //         }),
            //         id: "m" + watchlist.id
            //     }
            // })
        }
        load(){
            let self = this;
            this.analysisService.getWatchlists().then(function (watchlists: Watchlist[]){
                rootMorningstarPromise().then(function (promiseChain) {
                    console.log('initializing component');
                    self.transformWatchlistToMorningStarWatchlist(watchlists).then((mWatchlists: any[]) => {
                        loaderConfig.configuration.overrides.components.marketsHeatmap.settings.selectionlist.watchList = mWatchlists
                        if (self.state.params['watchlistId']) {
                            try {

                                loaderConfig.configuration.overrides.components.marketsHeatmap.settings.selectionlist.active = "m"+self.state.params['watchlistId']
                                //need to nullify the 'index' value as it takes precedent over the tickerList in the config
                                loaderConfig.configuration.overrides.components.marketsHeatmap.settings.index = null;
                                let tickers = [];
                                mWatchlists.filter(item => {
                                    return item.id == "m" + self.state.params['watchlistId'];
                                })[0].data.forEach(ticker => {
                                    tickers.push(ticker.ticker)
                                })

                                loaderConfig.configuration.overrides.components.marketsHeatmap.settings.tickerList = tickers
                            } catch (error) {
                                self.state.go('heatmap', {}, { inherit: false, reload: true})
                                alert('Could not load heatmap from watchlist')
                                return;
                            }
                        }else{
                            // need to reset to default values due to manilupating the configuration at runtime above.
                            // possibly look into a more elegant way to handle this
                            loaderConfig.configuration.overrides.components.marketsHeatmap.settings.selectionlist.active = 4;
                            loaderConfig.configuration.overrides.components.marketsHeatmap.settings.index = "146.10.XJO";
                            loaderConfig.configuration.overrides.components.marketsHeatmap.settings.tickerList = null;
                        }
                            initComponent(
                                "component-heatmap",
                                "heatmap-container",
                                "markets-components-heatmap",
                                "marketsHeatmap"
                            );
                    })
                });
            })
        }
    }
}
